// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__3XhPL","inputSuccess":"FieldCurrencyInput_inputSuccess__1mHn2","inputError":"FieldCurrencyInput_inputError__3BbqG"};